import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_BFF_API_URL,
  withCredentials: true,
});

export default api;
